import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Entry } from 'contentful';
import { LoginPage } from 'src/app/model/page/group/user/login-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { ModelValidator } from 'src/app/validator/model-validator';

@Component({
  selector: 'app-login-page',
  templateUrl: './login-page.component.html',
  styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit {
  loginPage: LoginPage = {} as LoginPage;
  submitted = false;
  loginForm: FormGroup = new FormGroup({
    email: new FormControl(''),
    password: new FormControl(''),
    RememberMe: new FormControl('')
  });
  constructor(private contentfulService: ContentfulService, private formBuilder: FormBuilder) {}

  ngOnInit(): void {
    const query = { 'fields.title': 'Login' };
    this.contentfulService.getPageContentWithEntries(query).then((loginPageEntries) => {
      if (loginPageEntries) {
        this.mapBanner(loginPageEntries);
      }
    });

    // console.log(this.loginPage);
    this.loginForm = this.formBuilder.group({
      eMail: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(20)]],
      RememberMe: []
    });
  }

  private mapBanner(loginPageEntries: Entry<any>[]) {
    loginPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let imageDetails: any = entry.fields['image'];
    let videoDetails: any = entry.fields['video'];
    this.loginPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: imageDetails.fields.file.url as string,
      video: videoDetails?.fields?.file?.url  as string
    };
  }
  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }
  onLoginFormSubmit() {
    this.submitted = true;
    if (this.loginForm.invalid) {
      return;
    }
  }
}
